import { render, staticRenderFns } from "./Asociarse.vue?vue&type=template&id=ca591cd2&"
import script from "./Asociarse.vue?vue&type=script&lang=js&"
export * from "./Asociarse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports